{
  "version": 1,
  "asset_id": "3a90f5ed-2ef9-45e6-9c71-f621f2f69533",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/3a90f5ed-2ef9-45e6-9c71-f621f2f69533/str-lifestyle-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/3a90f5ed-2ef9-45e6-9c71-f621f2f69533/str-lifestyle-placeholder.jpg",
  "original_filename": "str-lifestyle-placeholder.jpg",
  "size": 180826,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T15:30:48Z"
}
